/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Integration error code.
 */
export enum IntegrationErrorCode {
    INVALID_CREDENTIALS = 'invalid_credentials',
    AUTHORIZATION_FAILED = 'authorization_failed',
    PERMISSION_DENIED = 'permission_denied',
    INVALID_CONFIG = 'invalid_config',
    RATE_LIMITED = 'rate_limited',
    REMOTE_ERROR = 'remote_error',
    INTERNAL_ERROR = 'internal_error',
}
